(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teck-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-compare'))customElements.define('teck-compare',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const select=this.querySelector('select'),columns=[...this.querySelectorAll('[data-column]')],media=matchMedia('(max-width:749px)');
const update=()=>columns.forEach(column=>column.style.display=media.matches&&column.dataset.column!==select.value?'none':column.tagName==='COL'?'table-column':'table-cell');
select.addEventListener('change',update);media.addEventListener('change',update);update();
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teck-reasons"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-reasons'))customElements.define('teck-reasons',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('.teck-reasons__track'),originals=[...track.children],dots=[...this.querySelectorAll('[data-loop-index]')],n=originals.length;
if(n<2)return;
this.abort=new AbortController();const signal=this.abort.signal;
const clone=card=>{const c=card.cloneNode(true);c.setAttribute('aria-hidden','true');c.inert=true;c.removeAttribute('data-shopify-editor-block');c.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));c.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));c.querySelectorAll('video').forEach(v=>{v.removeAttribute('autoplay');v.preload='none'});return c};
track.prepend(...originals.map(clone));track.append(...originals.map(clone));
const cards=[...track.children];let current=0,touching=false,jumping=false,timer;
const position=i=>cards[i].offsetLeft-cards[0].offsetLeft;
const nearest=()=>{let index=n,distance=Infinity;cards.forEach((c,i)=>{const d=Math.abs(position(i)-track.scrollLeft);if(d<distance){index=i;distance=d}});return index};
const sync=i=>{current=((i-n)%n+n)%n;dots.forEach((d,k)=>{if(k===current)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};
const jump=i=>{jumping=true;track.style.scrollSnapType='none';track.scrollTo({left:position(i),behavior:'instant'});sync(i);requestAnimationFrame(()=>requestAnimationFrame(()=>{track.style.scrollSnapType='';jumping=false}))};
const settle=()=>{if(touching||jumping)return;const i=nearest();sync(i);if(i<n)jump(i+n);else if(i>=2*n)jump(i-n)};
const go=i=>{let delta=i-current;if(delta>n/2)delta-=n;if(delta<-n/2)delta+=n;track.scrollTo({left:position(nearest()+delta),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};
dots.forEach((d,i)=>d.addEventListener('click',()=>go(i),{signal}));
track.addEventListener('scroll',()=>{if(jumping)return;sync(nearest());clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('scrollend',settle,{signal});
track.addEventListener('touchstart',()=>{touching=true},{passive:true,signal});track.addEventListener('touchend',()=>{touching=false;clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((current+(e.key==='ArrowRight'?1:-1)+n)%n)}},{signal});
let width=0;this.observer=new ResizeObserver(()=>{if(Math.abs(width-track.clientWidth)>1){width=track.clientWidth;jump(n+current)}});this.observer.observe(track);jump(n);
this.cleanup=()=>{clearTimeout(timer);this.abort.abort();this.observer.disconnect()};
this.addEventListener('play',e=>{if(e.target.tagName==='VIDEO')this.querySelectorAll('video').forEach(v=>{if(v!==e.target)v.pause()})},{capture:true,signal});
}
disconnectedCallback(){if(this.cleanup)this.cleanup()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teck-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-stories'))customElements.define('teck-stories',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('.teck-stories__track'),originals=[...track.children],dots=[...this.querySelectorAll('[data-loop-index]')],n=originals.length;
if(n<2)return;
this.abort=new AbortController();const signal=this.abort.signal;
const clone=card=>{const c=card.cloneNode(true);c.setAttribute('aria-hidden','true');c.inert=true;c.removeAttribute('data-shopify-editor-block');c.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));c.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));c.querySelectorAll('video').forEach(v=>{v.removeAttribute('autoplay');v.preload='none'});return c};
track.prepend(...originals.map(clone));track.append(...originals.map(clone));
const cards=[...track.children];let current=0,touching=false,jumping=false,timer;
const position=i=>cards[i].offsetLeft-cards[0].offsetLeft;
const nearest=()=>{let index=n,distance=Infinity;cards.forEach((c,i)=>{const d=Math.abs(position(i)-track.scrollLeft);if(d<distance){index=i;distance=d}});return index};
const sync=i=>{current=((i-n)%n+n)%n;dots.forEach((d,k)=>{if(k===current)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};
const jump=i=>{jumping=true;track.style.scrollSnapType='none';track.scrollTo({left:position(i),behavior:'instant'});sync(i);requestAnimationFrame(()=>requestAnimationFrame(()=>{track.style.scrollSnapType='';jumping=false}))};
const settle=()=>{if(touching||jumping)return;const i=nearest();sync(i);if(i<n)jump(i+n);else if(i>=2*n)jump(i-n)};
const go=i=>{let delta=i-current;if(delta>n/2)delta-=n;if(delta<-n/2)delta+=n;track.scrollTo({left:position(nearest()+delta),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};
dots.forEach((d,i)=>d.addEventListener('click',()=>go(i),{signal}));
track.addEventListener('scroll',()=>{if(jumping)return;sync(nearest());clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('scrollend',settle,{signal});
track.addEventListener('touchstart',()=>{touching=true},{passive:true,signal});track.addEventListener('touchend',()=>{touching=false;clearTimeout(timer);timer=setTimeout(settle,180)},{passive:true,signal});
track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go((current+(e.key==='ArrowRight'?1:-1)+n)%n)}},{signal});
let width=0;this.observer=new ResizeObserver(()=>{if(Math.abs(width-track.clientWidth)>1){width=track.clientWidth;jump(n+current)}});this.observer.observe(track);jump(n);
this.cleanup=()=>{clearTimeout(timer);this.abort.abort();this.observer.disconnect()};
this.addEventListener('play',e=>{if(e.target.tagName==='VIDEO')this.querySelectorAll('video').forEach(v=>{if(v!==e.target)v.pause()})},{capture:true,signal});
}
disconnectedCallback(){if(this.cleanup)this.cleanup()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teck-utensils"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('teck-utensils'))customElements.define('teck-utensils',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];
const activate=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1});panels.forEach((panel,i)=>panel.hidden=i!==index);if(focus)tabs[index].focus()};
tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(index));tab.addEventListener('keydown',e=>{let next=index;if(e.key==='ArrowDown'||e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowUp'||e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activate(next,true)})});
this.addEventListener('shopify:block:select',e=>{const index=panels.findIndex(panel=>panel.contains(e.target)||panel===e.target);if(index>=0)activate(index)});
}
});

  } catch(e) { console.error(e); }
})();
})();
